<template>
  <b-container class="contentcontainer site-detail__note" v-show="show">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('site.description')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button v-show="!hasDescription & !editMode" v-on:click="setEditMode" class="btn btn--primary">
            {{$t('site.addnote')}}
          </button>
          <button v-show="hasDescription & !editMode" v-on:click="setEditMode" class="btn btn--primary">
            {{$t('site.editnote')}}
          </button>
          <button v-show="editMode" v-on:click="localSave" class="btn btn--primary">
            {{$t('site.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr v-show="hasDescription || editMode"/>
    <b-row v-show="hasDescription || editMode">
      <b-col>
        <div class="info" v-show="!editMode" v-html="formatSiteDescription">
        </div>
        <div class="info" v-show="editMode">
          <textarea
            v-model="newDescription"
            class="textarea-edit w-100"
            id="newDescriptionId"
          />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {

  name: 'NoteSection',

  computed: {
    ...mapState('site', [
      'siteDetail'
    ]),

    hasDescription () {
      return typeof this.siteDetail.data.description !== 'undefined' && this.siteDetail.data.description.length > 0
    },

    formatSiteDescription () {
      if (this.hasDescription) {
        return this.siteDescription.replace(/(?:\r\n|\r|\n)/g, '<br>')
      }

      return ''
    },

    siteDescription: {
      get () {
        return this.siteDetail.data.description
      },
      set (value) {
      }
    }
  },

  data () {
    return {
      editMode: false,
      newDescription: '',
      show: false
    }
  },

  watch: {
    'siteDetail': {
      handler: function () {
        if (typeof this.siteDetail.data.description !== 'undefined') {
          this.show = true
        }
      },
      deep: true
    }
  },

  methods: {

    ...mapActions('site', [
      'saveSiteDescription'
    ]),

    localSave () {
      this.editMode = false

      if (this.newDescription !== this.description) {
        let payload = {
          id: this.siteDetail.id,
          description: this.newDescription,
          context: {
            side_id: this.siteDetail.id
          }
        }

        this.saveSiteDescription(payload)
          .then(response => {
            this.siteDescription = this.newDescription
            this.$snotify.success('Saved successfully')
          })
          .catch(() => {
            this.$snotify.error('Error while Saving, please try again')
          })
      }
    },

    setEditMode () {
      this.newDescription = this.siteDescription
      this.editMode = true
    }
  }
}
</script>
